import { useMutation } from '@tanstack/react-query';

import {
  DebugSetUserRoleRequest,
  DebugSetUserSubscriptionRequest,
  DebugSetUserToplistLeagueRequest,
} from '~/server/src/dtos';

import { getFn, MessageResponse, postFn, queryClient, RequestError } from './api';
import { account } from './apiAccount';
import { users } from './apiUsers';

export const getDebug = `/debug`;
export const getClearDatabase = `${getDebug}/clearDatabase`;
export const getClearDatabaseLocal = `${getDebug}/clearDatabaseLocal`;
export const getClearDatabaseFirebase = `${getDebug}/clearDatabaseFirebase`;
export const postSetUserRole = `${getDebug}/setUserRole`;
export const postSetUserToplistLeague = `${getDebug}/setUserToplistLeague`;
export const postSetUserSubscription = `${getDebug}/setUserSubscription`;
export const getUpdateAllRankSilver = `${getDebug}/updateAllRankSilver`;
export const getUpdateAllRankGold = `${getDebug}/updateAllRankGold`;

export const useClearDatabase = () => {
  return useMutation<MessageResponse, RequestError>({
    mutationFn: () => getFn(getClearDatabase),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};

export const useClearDatabaseLocal = () => {
  return useMutation<MessageResponse, RequestError>({
    mutationFn: () => getFn(getClearDatabaseLocal),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};

export const useClearDatabaseFirebase = () => {
  return useMutation<MessageResponse, RequestError>({
    mutationFn: () => getFn(getClearDatabaseFirebase),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};

export const useSetUserRole = () => {
  return useMutation<MessageResponse, RequestError, DebugSetUserRoleRequest>({
    mutationFn: (args) => postFn(postSetUserRole, args),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};

export const useSetUserToplistLeague = () => {
  return useMutation<MessageResponse, RequestError, DebugSetUserToplistLeagueRequest>({
    mutationFn: (args) => postFn(postSetUserToplistLeague, args),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};

export const useSetUserSubscription = () => {
  return useMutation<MessageResponse, RequestError, DebugSetUserSubscriptionRequest>({
    mutationFn: (args) => postFn(postSetUserSubscription, args),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};

export const useUpdateAllRankSilver = () => {
  return useMutation<MessageResponse, RequestError>({
    mutationFn: () => getFn(getUpdateAllRankSilver),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};

export const useUpdateAllRankGold = () => {
  return useMutation<MessageResponse, RequestError>({
    mutationFn: () => getFn(getUpdateAllRankGold),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: users.all.queryKey });
      queryClient.invalidateQueries({ queryKey: account._def });
    },
  });
};
